// Angular Core
import { AiHubAuthModule } from "@aihub/core/authorization";
import { AiHubLoginPageModule } from "@aihub/ui/login-page";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
// Translation
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SharedModule } from "@shared";
import { DeloitteAiPageModule } from "@shared/page";
// import { MainMenuItems } from "./models/menu-items";
import { TransactionModule } from "@shared/transaction/transaction.module";
// Auth for Firebase
import { environment } from "@environments/environment";
// App Components
import { AppComponent } from "./app.component";
import { FeatureComponent } from "./components/product-detail-page/feature/feature.component";
import { PaymentPlanComponent } from "./components/product-detail-page/payment-plan/payment-plan.component";
import { SkuComponent } from "./components/product-detail-page/sku/sku.component";
import { InternationalizationModule } from "./internationalization/internationalization.module";
import { appRoutes } from "./router/app.router";


export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, "../assets/locales/", ".json");
}

@NgModule({
    declarations: [
        AppComponent,
        SkuComponent,
        PaymentPlanComponent,
        FeatureComponent,
    ],
    imports: [
        BrowserModule,
        StoreModule.forRoot({}),
        EffectsModule.forRoot(),
        RouterModule.forRoot(appRoutes, { relativeLinkResolution: "legacy", scrollPositionRestoration: 'enabled' }),
        HttpClientModule,
        InternationalizationModule.forRoot({ locale_id: "en-US" }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        SharedModule,
        /**
     * @todo remove MatIconModule if we clean up all components in ui
     * this is only used in the sku.component which is used in dara / covid19
     * but we should use @shared/cards for the same sku component
     */
        MatIconModule,
        TransactionModule.forRoot(environment.brain_base_url),
        DeloitteAiPageModule,
        //  .forRoot(MainMenuItems),
        AiHubAuthModule.forRoot({
            firebase: environment.firebase,
            params: environment.authParams,
            jwtInterceptHook: (uri: string) => uri.startsWith(environment.brain_base_url),
        }),
        AiHubLoginPageModule.forRoot(true),
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
